import { styled, Grid, Paper, Stack, Theme } from "@mui/material";
import { paletteVar, Typography } from "@platform/design-system";

export const CoveragesNav = styled(Paper)(({ theme }: { theme: Theme }) => ({
  padding: 0,
  ".MuiListItemButton-root": {
    padding: theme.spacing(2),
    "&:hover": {
      backgroundColor: paletteVar("surfaces-primary", "#EFF8FB"),
    },
  },
  h4: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
}));

export const CoveragesScrollingNav = styled(CoveragesNav)(
  ({ theme }: { theme: Theme }) => ({
    position: "sticky",
    top: "215px",
    overflowY: "scroll",
    minHeight: "150px",
    boxShadow: "none",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.brandSupporting.main,
    },
    "&::-webkit-scrollbar-track": {
      background: paletteVar("surfaces-neutral", "#f2f2f2"),
    },
    width: "100%",
  }),
);

export const StackAddCarrier = styled(Stack)(({ theme }: { theme: Theme }) => ({
  justifyContent: "space-around",
  gap: 18,
  ".MuiInputLabel-root:not(.Mui-focused)": {
    color: theme.palette.text.secondary,
  },
}));

export const SectionTitle = styled(Grid)(({ theme }: { theme: Theme }) => ({
  backgroundColor: paletteVar("surfaces-neutral", "#f2f2f2"),
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  padding: theme.spacing(1.5, 2),
  fontSize: 20,
  fontWeight: 800,
  lineHeight: "150%",
  letterSpacing: 1,
}));

export const DownloadTypography = styled(Typography)(() => ({
  cursor: "pointer",
  overflowWrap: "break-word",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
  "& .MuiTypography-root": {
    variant: "body1",
  },
}));

export const FileDownloadTypography = styled(Typography)(() => ({
  cursor: "pointer",
  overflowWrap: "break-word",
  letterSpacing: "0.7px",
  color: paletteVar("text-primary", "#00344F"),
  fontSize: "0.875rem",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
  "& .MuiTypography-root": {
    variant: "body1",
  },
}));
